// Whelan (UCD 2026), "The Parlay Puzzle": under CRRA utility with a small
// per-leg edge, prefer n legs over n - 1 when the geometric-mean per-leg
// probability exceeds this threshold.
export const WHELAN_THRESHOLDS = {
  2: 0.335,
  3: 0.526,
  4: 0.634,
  5: 0.703,
  6: 0.750,
  7: 0.784,
  8: 0.811,
  9: 0.831,
  10: 0.848,
};

/** Geometric mean of a probability array. */
export function geoMean(ps) {
  const meanLog = ps.reduce((sum, p) => sum + Math.log(p), 0) / ps.length;
  return Math.exp(meanLog);
}

/**
 * The largest leg count (2..min(max, length)) whose top-n geometric-mean
 * probability still clears the Whelan threshold for that count. Falls back
 * to 1 if no count clears, 0 for an empty input.
 */
export function optimalLegCount(pSortedDesc, { max = 10 } = {}) {
  if (pSortedDesc.length === 0) return 0;
  let best = 1;
  const limit = Math.min(max, pSortedDesc.length);
  for (let n = 2; n <= limit; n++) {
    if (geoMean(pSortedDesc.slice(0, n)) >= WHELAN_THRESHOLDS[n]) best = n;
  }
  return best;
}

/** The top-n active legs by p (n = optimalLegCount), input order preserved on ties. */
export function whelanLegs(activeLegs, { max = 10 } = {}) {
  const sorted = activeLegs
    .map((leg, i) => ({ leg, i }))
    .sort((a, b) => b.leg.p - a.leg.p || a.i - b.i)
    .map((x) => x.leg);
  const n = optimalLegCount(
    sorted.map((l) => l.p),
    { max },
  );
  return n === 0 ? [] : sorted.slice(0, n);
}
